/**
 * Start
 * @func toImageUrl
 * @desc concat imagePath with api host
 * @author izeberg
 * @param {string} imagePath - ชื่อไฟล์รูป (*.jpg))
 * @returns {string} http://localhost:8080/assets/images/{{folderPath}}/{{imagePath}}
 */
export const toImageUrl = imagePath => {
    return `${process.env.REACT_APP_UPLOAD_HOST}/${process.env.REACT_APP_IMAGE_PATH}/${imagePath}`;
};
/** End @func toImageUrl */

/**
 * @function parseJsonStr
 * @description convert json string to object
 * @param {string} str 
 * @returns {{[K: string]: any} | null}
 * @example
 * const obj = parseJsonStr('{foo: "abc"}');
 */
export function parseJsonStr(str){
    try {
        return JSON.parse(str)
    } catch (error) {
        console.error('[function] parseJsonStr :', error?.message);
        return null
    }
}